type Example = {
  text: string;
  results: string[];
};

type OperatorSectionProps = {
  id: string;
  title: string;
  description: React.ReactNode;
  sampleQueries: string[];
  correctExamples: Example[];
  incorrectExamples: Example[];
};

export default function OperatorSection({
  id,
  title,
  description,
  sampleQueries,
  correctExamples,
  incorrectExamples,
}: OperatorSectionProps) {
  return (
    <div className="space-y-2">
      {/* Operator title */}
      <h1 id={id} className="text-[18px] leading-5 font-bold -tracking-wide">
        {title}
      </h1>

      {/* Description */}
      <p className="text-sm leading-[140%] font-medium tracking-normal">
        {description}
      </p>

      {/* Sample Queries */}
      <div className="space-y-1">
        <h2 className="text-sm leading-5 font-bold -tracking-wide">
          Sample Queries:
        </h2>
        <ul className="list-inside list-disc pl-1 font-mono text-sm leading-[140%] font-normal tracking-normal">
          {sampleQueries.map((query, i) => (
            <li key={i}>{query}</li>
          ))}
        </ul>
      </div>

      {/* Correct Examples */}
      <div className="space-y-1">
        <h2 className="text-sm leading-5 font-bold -tracking-wide">
          Correct Results (TRUE):
        </h2>
        {correctExamples.map((ex, i) => (
          <div key={i} className="rounded-[12px] bg-green-50 p-3">
            <h3 className="text-sm leading-[140%] font-medium">{ex.text}</h3>
            <ul className="list-inside list-disc pl-2 font-mono text-sm leading-[140%] font-normal tracking-normal text-green-600">
              {ex.results.map((r, j) => (
                <li key={j}>{r}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Incorrect Examples */}
      <div className="space-y-1">
        <h2 className="text-sm leading-5 font-bold -tracking-wide">
          Incorrect Results (FALSE):
        </h2>
        {incorrectExamples.map((ex, i) => (
          <div key={i} className="rounded-[12px] bg-red-50 p-3">
            <h3 className="text-sm leading-[140%] font-medium">{ex.text}</h3>
            <ul className="text-destructive list-inside list-disc pl-2 font-mono text-sm leading-[140%] font-normal tracking-normal">
              {ex.results.map((r, j) => (
                <li key={j}>{r}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
